module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/duplex-browser.js
// module id = 1925
// module chunks = 0